export const data = {
  buttons: [
    { label: 'I was signed up without being told.', id: 'withoutConsent', isFocused: true },
    { label: "I wasn't told I could have a free bank account instead.", id: 'notTold' },
    { label: 'I was told having one would improve my credit score.', id: 'improveCredit' },
    {
      label:
        'I was told I would get deals on other financial products or services by taking out this account.',
      id: 'getDeals',
    },
    {
      label:
        'I was told I had to get a packaged account in order to access other products such as a loan or mortgage.',
      id: 'hadToGet',
    },
    {
      label: 'I signed up to an account but was unable to claim on one or more of the benefits.',
      id: 'couldNotClaimBenefit',
    },
    { label: 'Something else.', id: 'somethingElse' },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/245163d11700-tooliconpiggybank.jpg',
  },
  title: 'What led you to having a packaged bank account?',
}
